import { ICandidate, newMappingEntity } from 'wisestep-api';

import CareerBuilderEdgeCandidates from '../types/CareerBuilderEdgeCandidates';
import CareerBuilderEdgeResponse from '../types/CareerBuilderEdgeResponse';

export const processCareerBuilderEdgeResponse = (response: any): CareerBuilderEdgeResponse => {
  let noresponse = false;
  const modifiedResponse: CareerBuilderEdgeResponse = {
    candidates: [],
  };
  const totalItems = response?.TotalResults;

  if (!response.Results) {
    noresponse = true;
  }
  const candidates = response.Results;
  const candidatesResponse = buildCandidateRecords(candidates);
  modifiedResponse.candidates = candidatesResponse;
  modifiedResponse.noResponse = noresponse;
  modifiedResponse.totalItems = totalItems;
  modifiedResponse.facets = response.Facets;
  return modifiedResponse;
};

function buildCandidateRecords(
  candidates: CareerBuilderEdgeCandidates[]
): CareerBuilderEdgeCandidates[] {
  candidates.map((candidate) => {
    const candidateData: ICandidate = newMappingEntity();

    candidateData.name = candidate.Name;
    candidateData.currentJobTitle = candidate.JobTitle;
    candidateData.source = 'CAREER BUILDER EDGE';
    candidateData.dateLastActiveOnJobBoard = candidate.Attributes.LastAccessed ?? '';
    candidateData.dateResumeLastUpdatedOnJobBoard = candidate.ResumeLastModified;
    candidate.candidateData = candidateData;
  });
  return candidates;
}
